/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc
 */
import * as References from './StandardizedInstallOptInRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc#addStandardizedInstallOptIn
 */
export const ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallOptInRpc_addStandardizedInstallOptIn';
export const ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.addStandardizedInstallOptInRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc#removeStandardizedInstallOptIn
 */
export const REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallOptInRpc_removeStandardizedInstallOptIn';
export const REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.removeStandardizedInstallOptInRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc#getStandardizedInstallOptIn
 */
export const GET_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallOptInRpc_getStandardizedInstallOptIn';
export const GET_STANDARDIZED_INSTALL_OPT_IN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STANDARDIZED_INSTALL_OPT_IN_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getStandardizedInstallOptInRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc#batchCheckStandardizedInstall
 */
export const BATCH_CHECK_STANDARDIZED_INSTALL_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallOptInRpc_batchCheckStandardizedInstall';
export const BATCH_CHECK_STANDARDIZED_INSTALL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: BATCH_CHECK_STANDARDIZED_INSTALL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.batchCheckStandardizedInstallRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});